module.exports = __webpack_public_path__ + "static/media/view3.59342039.jpg";